<ng-container [ngSwitch]="vraag.vraagtype">
  <ng-container *ngSwitchDefault>
    <div *ngIf="(resultaten$ | async) as resultaten" class="ols-failure-text">
      <div *ngFor='let regel of vraagregels' [innerHTML]="regel"></div>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="vraagtype.GeenDekkingRuit">
    <ng-container *ngIf="(resultaten$ | async) as resultaten">
      <div>{{tekstDeel1(vraag.vraagregels)}}</div>
      <div [innerHTML]="tekstDeel2(vraag.vraagregels)"></div>
      <div class="buttons-container">
        <a (click)="redirect()" class="button button--schade has-ripple"
          id="ipoclick-btn-{{geefPazaProces()}}-kiezer-dekking_niet_aanwezig">{{vraag.button_text}}</a>
      </div>
    </ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="vraagtype.OnlineNietMogelijk">
    <div class="ols-contact-telefoon">
      <div class="ols-contact">
        <div class="icon"></div>
      </div>
      <div>
        <div class="ols-title">{{vraagtitel}}</div>
        <div *ngFor='let regel of vraag.vraagregels' [innerHTML]="regel"></div>
      </div>
    </div>
    <div class="buttons-container">
      <a (click)="redirect()" class="button button--schade has-ripple" href="tel:+31135801234"
        id="ipoclick-btn-{{geefPazaProces()}}-schademelden-online_niet_mogelijk">Bel ons</a>
    </div>
  </ng-container>
</ng-container>

<div *ngIf="vraag.vraagtype === vraagtype.VerzekeringNietAfgesloten" class="buttons-container">
  <a (click)="redirect()" class="button button--schade has-ripple"
    id="ipoclick-btn-{{geefPazaProces()}}-kiezer-verzekering_niet_aanwezig">{{vraag.button_text}}</a>
</div>